"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.SIZE_OPTIONS = exports.TYPE_OPTIONS = void 0;
var TYPE_OPTIONS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  CRITICAL: "critical",
  WHITE: "white",
  PRIMARY_SUBTLE: "primarySubtle",
  CRITICAL_SUBTLE: "criticalSubtle"
};
exports.TYPE_OPTIONS = TYPE_OPTIONS;
var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var TOKENS = {
  // Size tokens
  heightButton: "heightButton",
  loadingWidth: "loadingWidth",
  loadingHeight: "loadingHeight",
  fontSizeButton: "fontSizeButton",
  paddingButton: "paddingButton",
  paddingButtonWithIcons: "paddingButtonWithIcons",
  paddingButtonWithLeftIcon: "paddingButtonWithLeftIcon",
  paddingButtonWithRightIcon: "paddingButtonWithRightIcon",
  // Type tokens
  backgroundButton: "backgroundButton",
  backgroundButtonHover: "backgroundButtonHover",
  backgroundButtonActive: "backgroundButtonActive",
  backgroundButtonFocus: "backgroundButtonFocus",
  colorTextButton: "colorTextButton",
  colorTextButtonHover: "colorTextButtonHover",
  colorTextButtonActive: "colorTextButtonActive",
  borderColorButtonFocus: "borderColorButtonFocus"
};
exports.TOKENS = TOKENS;